export default "__VITE_ASSET__11b3d78a__"